// removed by extract-text-webpack-plugin
module.exports = {"img-responsive":"KNmhLkmTXTBs7OPgMl2y9","image-container":"hfAPZJzVggtZNRr66WETk","image-container--1-1":"_1Mf1ltH6QezwI_Us_oUoO3","image-container--16-9":"Yl9oLRBIbltFZ7VqNX-mt","image-container--3-2":"_18P9q7V4hi3gXfpEc4WGIW","image-container--fb-ratio":"_3gtoX8MgCog5GTRbrlBio_","image":"BRiPqt9aKMmR1Dlf7M2I2","lecture-item":"_1G_RvstmFzFP7wITm-i0p-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Image/image.scss
// module id = 1350
// module chunks = 0